var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconControlShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4039 17.6681C23.4381 15.9002 24 13.896 24 11.802C24 7.46853 21.6067 3.68377 18.058 1.63113C18.037 1.61523 18.0224 1.59296 17.999 1.58023C17.9812 1.5691 17.9586 1.56989 17.94 1.56115C16.187 0.573401 14.1616 0 12.0004 0C9.83917 0 7.81457 0.573401 6.06246 1.55956C6.04225 1.56989 6.02041 1.56989 6.00101 1.58103C5.97675 1.59455 5.9622 1.61841 5.94037 1.63352C4.17532 2.65387 2.70215 4.10209 1.66317 5.8374C1.647 5.86046 1.62356 5.87398 1.609 5.89864C1.59768 5.91852 1.59768 5.94079 1.58879 5.95987C0.586194 7.68167 0.00404272 9.66829 0.00242563 11.7901C0.00242563 11.7933 0 11.7965 0 11.8013C0 11.8052 0.00161709 11.8084 0.00242563 11.8132C0.00404272 13.9008 0.562746 15.8994 1.59202 17.6617Z",
    fill: "#B075FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconControlShield);
export default __webpack_public_path__ + "static/media/icon_control_shield.aaa749be14d61e1a9ca22e8da9b8ea96.svg";
export { ForwardRef as ReactComponent };